import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Übergangs-Bildschirm zwischen Schritt 1 (Identify) und dem
 * tatsächlichen Browser-Redirect zum IdP. Zeigt dem User, dass er
 * gleich umgeleitet wird, damit der kurze Moment zwischen Form-Submit
 * und window.location-Change nicht wie "passiert nichts" wirkt.
 *
 * Kein Cancel-Button — Browser-Back ist der natürliche Escape-Pfad.
 */
@Component({
  selector: 'app-login-sso-redirect',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="t2d-login__form-header">
      <h2 class="t2d-login__form-title">Anmelden</h2>
    </div>
    <div class="t2d-login__redirect">
      <p class="t2d-login__redirect__lead">Weiterleitung zu</p>
      <p class="t2d-login__redirect__mandant">{{ mandantName }}</p>
      <div class="t2d-login__spinner-dots" aria-label="Lädt">
        <span></span><span></span><span></span>
      </div>
    </div>
  `,
})
export class LoginSsoRedirectComponent {
  @Input({ required: true }) mandantName!: string;
}
